import axios from 'axios';

// In production, use the same origin (server serves both API and static files)
// In development, use the proxy configured in package.json
const baseURL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : '/api';

const api = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;

